import { createRoute, type AnyRoute } from "@tanstack/react-router";
import { DollarSign } from "lucide-react";

import { PlaceholderPage } from "@/components/cinch/PlaceholderPage";
import type { FeatureModule } from "@/features/types";
import { guarded } from "@/lib/auth";

function PricingPage() {
  return (
    <PlaceholderPage
      title="Pricing & Packaging"
      description="SKUs, packages, and cost-per-unit, synced with QuickBooks."
      icon={DollarSign}
      plannedCapabilities={[
        "SKU catalog with active/retired states",
        "Package definitions (SKU bundles + price overrides)",
        "Cost-per-unit calc from QuickBooks expense feed",
        "Price-history audit for renegotiations",
      ]}
    />
  );
}

export const pricingModule: FeatureModule = {
  key: "pricing",
  nav: {
    label: "Pricing",
    icon: DollarSign,
    to: "/pricing",
    requires: "pricing.read",
    order: 80,
    group: "Revenue",
  },
  routes: (rootRoute) => [
    createRoute({
      getParentRoute: () => rootRoute,
      path: "/pricing",
      component: guarded("pricing.read", PricingPage),
    }),
  ] as unknown as AnyRoute[],
};
